import { useRef } from 'react';
import {
  ChakraFlex,
  coalescePlainTextToEditorV2Html,
  EditorV2,
  EditorV2State,
  FAIconName,
  FireflyIconButton,
  SectionCard,
  Text,
} from '@equip.health/ui';

interface AftercareSectionCardProps {
  id: string;
  label: string;
  value: string;
  onClickEdit: () => void;
  isSigned: boolean;
}

const AftercareSectionCard = ({
  id,
  label,
  value,
  onClickEdit,
  isSigned,
}: AftercareSectionCardProps) => {
  const editorRef = useRef<EditorV2State>(null);
  const htmlContent = coalescePlainTextToEditorV2Html(value);

  const sectionId = `aftercare-${id}`;

  return (
    <SectionCard id={sectionId}>
      <ChakraFlex flexDirection="column" gap="6px" width="100%">
        <ChakraFlex alignItems="center" justifyContent="space-between">
          <Text id={`${sectionId}-label`} variant="bodyMedium">
            {label}
          </Text>
          {!isSigned && (
            <FireflyIconButton
              ariaLabel={`edit-${sectionId}`}
              color="primary.100"
              icon={FAIconName.penRegular}
              id={`edit-${sectionId}`}
              name={FAIconName.penRegular}
              onClick={onClickEdit}
              variant="tertiary"
            />
          )}
        </ChakraFlex>
        <EditorV2
          ariaProps={{
            input: { 'aria-labelledby': `${sectionId}-label` },
          }}
          containerTestId={`${sectionId}-editor`}
          hideBorder
          initialContent={htmlContent}
          key={htmlContent}
          readOnly
          stateRef={editorRef}
        />
      </ChakraFlex>
    </SectionCard>
  );
};

export default AftercareSectionCard;
